import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { RouteComponentProps, withRouter } from "react-router"
import GlobalHelper from "../../common/GlobalHelper"
import Icon from "../../common/icon/icon.component"
import { getDefaultSortId } from "../../common/listing/generic-listing/utils"
import DivStatBoxWrapper from "../../common/rich-text/feature-protection-wrappers/divStatBoxWrapper.component"
import { isError } from "../../state/helpers/Error"
import { ObjectType } from "../../state/listing/generic-listing"
import SearchService from "../../state/search/SearchService"
import Shortcut from "../../state/shortcut/Shortcut"
import ShortcutService from "../../state/shortcut/ShortcutService"
import ShortcutsSettingsModal from "./ShortcutsSettingsModal"
import { filterObjectsRequiredFeatures, objectMapping } from "./helpers.jsx"

const getRedirectLink = (shortcut: Shortcut) => {
    return objectMapping[shortcut.getSavedFilterListingType()] ?? ["", ""]
}

type OwnProps = {
    isEditable: boolean,
    shortcut: Shortcut,
    locationId: string,
    handleShortcutsList: (shortcutType: string, updatedShortcut: Shortcut, handleType: string) => void,
}

const ShortcutFilterComponent: React.FC<OwnProps & RouteComponentProps> = (props) => {

    const [totalValue, setTotalValue] = useState<object>({})
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0)
    const [settingsModal, setSettingsModal] = useState(<></>)
    const [errorMsg, setErrorMsg] = useState<string>("")
    const [redirectLink, savePrefType] = getRedirectLink(props.shortcut)
    const locationIdArray = Array(1).fill(props.locationId)

    const {fields, totals, filters} = SearchService.getTotalsFiltersAndFields({
        ...props,
        shortcutFilter: props.shortcut,
        typeOfSearch: props.shortcut.getSavedFilterListingType(),
    })

    useEffect(() => {
        getSearchTotal()
    }, [props.locationId, props.shortcut])

    const openShortcutsSettingsModal = (event: React.MouseEvent) => {
        event.preventDefault()
        setSettingsModal(
            <ShortcutsSettingsModal
                shortcut={props.shortcut}
                onClose={closeShortcutsSettingsModal}
                handleShortcutsList={props.handleShortcutsList}
            />
        )
    }

    const closeShortcutsSettingsModal = () => {
        setSettingsModal(<></>)
    }

    const getAmountFromListingType = () => {
        switch (props.shortcut.getSavedFilterListingType()) {
        case "quotes":
            return "baseCurrencyTotalValueAmount"
        case "price-lists":
            return "amountOfOrders"
        default:
            return "baseCurrencyTotalAmount"
        }
    }

    const getObjectListingType = () => {
        return props.shortcut.getSavedFilterListingType() == "subscription" ?
            "invoices" : props.shortcut.getSavedFilterListingType()
    }

    const deleteShortcut = () => {
        ShortcutService.deleteShortcut(props.shortcut.getId()).then((r) => {
            if (!isError(r)) {
                props.handleShortcutsList(props.shortcut.getShortcutType(), props.shortcut, "delete")
            } else {
                setErrorMsg(r.message)
            }
        })

    }

    const savePref = () => {
        return GlobalHelper.saveListingPreferences(
            savePrefType,
            1,
            10,
            "",
            "",
            false,
            false,
            getDefaultSortId(getObjectListingType() as ObjectType) || "identifier",
            false,
            props.shortcut.getSavedFilterDecodedContent(),
            props.shortcut.getSavedFilterId(),
        )
    }

    const redirectOnClick = async () => {
        if (!props.isEditable) {
            await savePref()
            props.history.push(`/${redirectLink}/listing`)
        }
    }

    const getSearchTotal = () => {
        const newPostData = SearchService.getSearchPostData(
            props.shortcut.getSavedFilterDecodedContent(),
            props.shortcut.getSavedFilterListingType(),
            filters,
            "",
            [getObjectListingType()],
            totals,
            fields,
            "*"
        )

        if (props.locationId !== "all") {
            newPostData.filters["locationId"] = locationIdArray
        }

        SearchService.mainSearchTotals(newPostData).then((r) => {
            if (!isError(r)) {
                setTotalValue(r.getTotals())
                setTotalItemsCount(r.getTotalItemsCount())
            }
        })
    }

    const getProtectionRule = () => {
        if (filterObjectsRequiredFeatures[redirectLink]) {
            return filterObjectsRequiredFeatures[redirectLink].reduce((final, feature) => {
                return final && AppContext.accountFeatureIsEnabled(feature)
            }, true) || props.isEditable
        }
        return true
    }

    return (
        <div className={props.isEditable ? "col-sm-12" : ""}>
            <div className="text-danger">{errorMsg}</div>
            <DivStatBoxWrapper
                onClick={redirectOnClick}
                protectedClassName={props.isEditable ? "col-sm-12" : ""}
                redirectToAccount={true}
                premium={false}
                label={props.shortcut.getName()}
                colorStyle={"text-" + props.shortcut.getColor()}
                boxType={"open"}
                count={totalItemsCount}
                protectionRule={getProtectionRule()}
                className={"success-box"}
                isDashboard={true}
                isEditable={props.isEditable}
                amount={totalValue && totalValue[getAmountFromListingType()]}
            >
                {props.isEditable &&
                    <div>
                        <button
                            className={"mr-1 mb-2 btn-sm btn-primary"}
                            onClick={openShortcutsSettingsModal}>
                            <Icon value={"edit"}/>
                        </button>
                        <button
                            className={"mr-1 mb-2 btn-sm btn-danger"}
                            onClick={deleteShortcut}>
                            <Icon value={"trash"}/>
                        </button>
                    </div>
                }
            </DivStatBoxWrapper>
            {settingsModal}
        </div>
    )
}

export default injectIntl(withRouter(ShortcutFilterComponent))



// WEBPACK FOOTER //
// ./src/shortcuts/components/ShortcutFilterComponent.tsx